import * as React from 'react';
import {
  AlertDialog as AlertDialogChakra,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
} from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

export interface IAlertDialogData {
  clickAction: () => void;
  descriptionText?: string | React.ReactElement;
  modalTitle: string;
  confirmationButtonText: string;
}

export interface IProps {
  id: string;
  isOpen: boolean;
  modalTitle: string;
  descriptionText: string | React.ReactElement;
  confirmationButtonText: string;
  onClose: () => void;
  onClickSuccess: () => void;
}

const AlertDialog: React.FC<IProps> = props => {
    const { t } = useTranslation('dialogs');
  const { isOpen, onClose, onClickSuccess, modalTitle, descriptionText, confirmationButtonText } = props;
  const cancelRef = React.useRef(null);

  return (
    <AlertDialogChakra leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>{modalTitle}</AlertDialogHeader>

          <AlertDialogBody>{descriptionText}</AlertDialogBody>

          <AlertDialogFooter>
            <Button data-selector="alert-dialog-cancel-button" ref={cancelRef} onClick={onClose}>
              {t('common:cancel')}
                                      </Button>

            <Button data-selector="alert-dialog-confirm-button" variant="solid" onClick={onClickSuccess} ml={3}>
              {confirmationButtonText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialogChakra>
  );
};

export default AlertDialog;
